import { EventEmitter } from "modules/shared/helpers/event-emitter";
export var stickyPlayerEventEmitter = new EventEmitter();
export var SPEED_OPTIONS = [
    1,
    .75,
    1.25,
    1.5,
];
export var DEFAULT_VOLUME = 70;
